module.exports = __webpack_public_path__ + "img/顺时针旋转90度2.53129600.svg";